<template lang="pug" src="./tabs-map.pug"></template>

<script>
import Icon from 'components/icon/icon'

export default {
  props: ['props'],
  data () {
    return {
      active: 1
    }
  },
  components: {
    Icon
  },
  created () {
    screen.width > 500 ? '' : this.active = true
  }
}
</script>



// WEBPACK FOOTER //
// tabs-map.vue?382d37fe